import script from "./CellForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CellForm.vue?vue&type=script&setup=true&lang=js"

import "./CellForm.vue?vue&type=style&index=0&id=5390b952&lang=css"

const __exports__ = script;

export default __exports__